<template>
  <iVideoContainer
    :src="videoSrc"
    :height="getOptionValue(LayoutHeight)"
    :min-height="getOptionValue(MinHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :width="getOptionValue(LayoutWidth)"
    :min-width="getOptionValue(MinWidth)"
    :max-width="getOptionValue(MaxWidth)"
    :autoplay="getOptionValue(Autoplay)"
    :controls="getOptionValue(Controls)"
    :muted="getOptionValue(Muted)"
    :loop="getOptionValue(Loop)"
    :poster="getOptionValue(Poster)"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :style-overrides="videoStyleOverrides"
  />
</template>

<script>
import { StandardVideoElementMixin } from
  "%/dynamic-component-editor/standard-elements/video-element/standard-video-element-mixin";
import { SingleVideoElementMixin } from "%/dynamic-component-editor/standard-elements/video-element/single-video-element-mixin";
import VideoOptions from "%/dynamic-component-editor/bundles/video-options";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import { mediaIdFromValue } from "%/lib/media-reference";
import { useMediaPlaybackStore } from "%/stores/media-playback-store";

export default {
  name: "DynamicAppVideoElement",
  elementPanelSettings: {
    displayName: "Video",
    elementGroup: "general",
    displayIcon: "video",
    elementType: "element",
  },
  hidden: true,
  mixins: [StandardVideoElementMixin, SingleVideoElementMixin, DynamicElementWithContext],
  optionBundles: [
    new VideoOptions({}, {
      "single-video": true,
    }),
  ],
  data() {
    return {
      resolvedMediaUrl: "",
    };
  },
  computed: {
    // The stored value is either a media_id (new) — resolved to a fresh HLS/
    // source URL at render — or a legacy baked URL, used directly. iVideoContainer
    // handles HLS-vs-progressive from the URL.
    videoSrc() {
      if (mediaIdFromValue(this.valueFromContext) !== null) {
        return this.resolvedMediaUrl;
      }
      return this.valueFromContext;
    },
  },
  watch: {
    valueFromContext: {
      immediate: true,
      handler() {
        this.resolveMediaUrl();
      },
    },
  },
  methods: {
    resolveMediaUrl() {
      const mediaId = mediaIdFromValue(this.valueFromContext);
      if (mediaId === null) {
        this.resolvedMediaUrl = "";
        return;
      }
      useMediaPlaybackStore().resolveMediaPlayback(mediaId, data => {
        this.resolvedMediaUrl = data.url;
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
